import { render } from "./AddWebhookDialog.vue?vue&type=template&id=06f78576&scoped=true&lang=pug"
import script from "./AddWebhookDialog.vue?vue&type=script&lang=js"
export * from "./AddWebhookDialog.vue?vue&type=script&lang=js"

import "./AddWebhookDialog.vue?vue&type=style&index=0&id=06f78576&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f78576"]])

export default __exports__